import { useId } from "react";
import Modal from "./Modal";

export default function ConfirmDeactivation({
  isOpen,
  onCancel,
  onConfirm,
}: {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}) {
  const titleId = useId();
  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      titleId={titleId}
      title="Confirm deactivation"
      footer={
        <>
          <button type="button" className="secondaryButton" onClick={onCancel}>
            Cancel
          </button>
          <button type="button" className="primaryButton" onClick={onConfirm}>
            Deactivate
          </button>
        </>
      }
    >
      <p>
        This record will remain in lists and reports, but will no longer be
        available when creating episodes. You can reactivate it later.
      </p>
    </Modal>
  );
}
